import { ROOT, USER_REGISTER, REGISTER_DUPPLICATION_API } from "@/_helpers/constant.js";

import { requestOptions, handleResponse } from "@/_helpers";

function register(data) {
    return fetch(ROOT + USER_REGISTER, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function registerDupplication(data) {
    return fetch(ROOT + REGISTER_DUPPLICATION_API, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

export const registerService = {
    register,
    registerDupplication
};